import React from "react";

function TechnologyImg({ src }) {
  return (
    <div className="max-h-4">
      <img src={src} className="max-h-6" />
    </div>
  );
}

export default TechnologyImg;
